// extracted by mini-css-extract-plugin
export var dataSection = "styles-module__dataSection___zgMoI";
export var label = "styles-module__label___xz5xq";
export var section = "styles-module__section___nefNN";
export var title = "styles-module__title___bkBFs";